export enum Types {
  REFRESH_AUTH_TOKEN_REQUEST = 'auth/REFRESH_AUTH_TOKEN_REQUEST',
  REFRESH_AUTH_TOKEN_SUCCESS = 'auth/REFRESH_AUTH_TOKEN_SUCCESS',
  REFRESH_AUTH_TOKEN_FAILURE = 'auth/REFRESH_AUTH_TOKEN_FAILURE',
  UPDATE_AUTH_STATE_SUCCESS = 'auth/UPDATE_AUTH_STATE_SUCCESS',
  UPDATE_AUTH_STATE_FAILURE = 'auth/UPDATE_AUTH_STATE_FAILURE',
  LOAD_AUTH_STATE = 'auth/LOAD_AUTH_STATE',
  LOAD_AUTH_STATE_REQUEST = 'auth/LOAD_AUTH_STATE_REQUEST',
  LOAD_AUTH_STATE_SUCCESS = 'auth/LOAD_AUTH_STATE_SUCCESS',
  LOAD_AUTH_STATE_FAILURE = 'auth/LOAD_AUTH_STATE_FAILURE',
  COMMERCE_TOKEN_AVAILABLE = 'auth/COMMERCE_TOKEN_AVAILABLE',
  SHOW_COMMERCE_TOKEN_MODAL = 'auth/SHOW_COMMERCE_TOKEN_MODAL'
}

export const RENEW_TOKEN_INTERVAL_MILLISECONDS = 1800000;
export const MILLISECONDS_OF_A_MINUTE = 60000;
export const MILLISECONDS_OF_A_SECOND = 1000;

export interface IRefreshAuthToken {
  expires_in: string;
  access_token: string;
}

export interface IAuthState {
  azureToken: string;
  azureExpireIn: number;
  azureDateTimeExpiration: number;
  commerceTokenAvailable?: boolean;
  showCommerceTokenModal?: boolean;
  tryAgainRoute?: string;
}
